import {
  GQFootprintsForFootprintSelectorQuery,
  GQUpdateFootprintReviewRequestStatusMutation,
} from '../../generated/graphql-operations';

export function mergeWatershedFootprintReviewRequestIntoFootprintSelector(
  data: GQFootprintsForFootprintSelectorQuery | null,
  payload: GQUpdateFootprintReviewRequestStatusMutation['updateWatershedFootprintReviewRequestStatus']
): GQFootprintsForFootprintSelectorQuery | null {
  if (data === null) {
    return null;
  }

  const updatedFootprints = data.footprints.edges.map((edge) => {
    if (!edge?.node) {
      return null;
    }

    const updatedSnapshots = edge.node.footprintSnapshots.map((snapshot) => {
      if (
        snapshot.watershedFootprintReviewRequest?.id ===
        payload.watershedFootprintReviewRequest.id
      ) {
        return {
          ...snapshot,
          watershedFootprintReviewRequest: {
            ...snapshot.watershedFootprintReviewRequest,
            status: payload.watershedFootprintReviewRequest.status,
          },
        };
      }
      return snapshot;
    });

    return {
      ...edge,
      node: {
        ...edge.node,
        footprintSnapshots: updatedSnapshots,
      },
    };
  });

  return {
    ...data,
    footprints: {
      ...data.footprints,
      edges: updatedFootprints,
    },
  };
}
